var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#004D93"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30H50V33.75H32.5M32.5 23.75H50V27.5H32.5M32.5 36.25H50V40H32.5M52.5 10H7.5C6.17392 10 4.90215 10.5268 3.96447 11.4645C3.02678 12.4021 2.5 13.6739 2.5 15V47.5C2.5 48.8261 3.02678 50.0979 3.96447 51.0355C4.90215 51.9732 6.17392 52.5 7.5 52.5H52.5C53.8261 52.5 55.0979 51.9732 56.0355 51.0355C56.9732 50.0979 57.5 48.8261 57.5 47.5V15C57.5 13.6739 56.9732 12.4021 56.0355 11.4645C55.0979 10.5268 53.8261 10 52.5 10ZM52.5 47.5H30V15H52.5",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.da7641fefe12ab826e7affd7975d37fa.svg";
export { ForwardRef as ReactComponent };